import { ClientsService } from '../../shared/services/clients.service';
import { Component, OnInit, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationsService } from '../../shared/services/notifications.service';
import { ConfirmationDialogService } from '../../shared/confirmation-dialog/confirmation-dialog.service';

@Component({
    selector: 'app-clients-page',
    templateUrl: './clients-page.component.html'
})
export class ClientsPageComponent implements OnInit, OnDestroy {

    public items;
    public itemsCount;

    @ViewChild("content", { static: false })
    private modal: TemplateRef<any>;
    public modalFormModel;

    public filterFormModel = { page: 1, pageSize: 10, name: "" };

    constructor(
        private clientsService: ClientsService,
        private modalService: NgbModal,
        private spinner: NgxSpinnerService,
        private notifications: NotificationsService,
        private confirmationDialogService: ConfirmationDialogService) { }

    ngOnInit() {
        this.list();
    };

    ngOnDestroy() {
        this.modalService.dismissAll();
    };

    listPage(page: number) {
        this.filterFormModel.page = page;
        this.list();
    };

    list() {
        this.spinner.show();
        this.clientsService.list(this.filterFormModel).subscribe(response => {
            this.items = response.data;
            this.itemsCount = response.count;
            this.spinner.hide();
        });
    };

    clearFilter() {
        this.filterFormModel.name = "";
        this.list();
    };

    create() {
        this.modalFormModel = {
            active: true
        };
        this.modalService.open(this.modal, { size: 'lg', backdrop: 'static', keyboard: false });
    };

    update(post) {
        this.spinner.show();
        this.clientsService.get(post.id).subscribe(response => {
            this.modalFormModel = response;
            this.modalService.open(this.modal, { size: 'lg', backdrop: 'static', keyboard: false });
            this.spinner.hide();
        });
    };

    submitModalFormModel(form) {
        if (!form.valid) {
            Object.keys(form.controls).forEach(key => form.controls[key].markAsDirty());
            return;
        }

        if (this.modalFormModel.id && !form.dirty) {
            this.modalService.dismissAll();
            return;
        }

        let requestModel = Object.assign({}, this.modalFormModel);

        let outerThis = this;
        let callback = function (response) {
            outerThis.spinner.hide();
            if (!response.success) {
                outerThis.notifications.errors(response.payload.messages);
                return;
            }


            outerThis.notifications.success(!outerThis.modalFormModel.id ? 'Cadastro de novo cliente realizado com sucesso.' : 'Dados do cliente atualizados com sucesso.');
            outerThis.modalService.dismissAll();
            outerThis.list();
        };

        if (requestModel.id) {
            // update
            this.spinner.show();
            this.clientsService.update(requestModel).subscribe(callback);
        } else {
            // create
            this.spinner.show();
            this.clientsService.create(requestModel).subscribe(callback);
        }
    };

    closeModalFormModel(form) {
        if (!form.dirty) {
            this.modalService.dismissAll();
            return;
        }

        let outherThis = this;
        let confirmedCallback = function (confirmed) {
            if (!confirmed) {
                return;
            }
            outherThis.modalService.dismissAll();
        };

        this.confirmationDialogService.confirm('Tem certeza de que deseja cancelar as alterações realizadas ?', "Sim", "Não").then(confirmedCallback);
    };

    delete(post) {
        let outherThis = this;
        let confirmedCallback = function (confirmed) {
            if (!confirmed) {
                return;
            }
            outherThis.spinner.show();
            outherThis.clientsService.delete(post).subscribe(response => {
                outherThis.spinner.hide();
                if (!response.success) {
                    outherThis.notifications.errors(response.payload.messages);
                    return;
                }
                outherThis.notifications.success('Cadastro de cliente removido com sucesso.');
                outherThis.list();
            });
        };

        this.confirmationDialogService.confirm('Tem certeza de que deseja remover este cliente ?').then(confirmedCallback);
    };
}
